// Wortlaute der Erklärung „Kunden“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Reiter und Schaltflächen stehen so, wie die Kundenakte sie zeigt (../customer.js).
export default {
  title: "Kunden",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    CustomerOverview: "Übersicht",
    CustomerDetail: "Kundenakte",
    ProjectDetail: "Projekt",
    SettingsOverview: "Einstellungen",
  },
  // Die Seiten außerhalb der Kundenverwaltung, in denen ein Kunde wirkt. In der Zeitleiste abgesetzt.
  related: "Zusammenhänge",
  step: {
    list: {
      text: "Hier stehen alle Kunden Ihres Betriebs, jeder mit einer eigenen Akte.",
    },
    row: {
      text: "Die Zeile zeigt Unternehmen und Ort, den ersten Ansprechpartner mit Telefon und die Zahl der Projekte. Die Zahl öffnet genau diese Projekte, ein Klick auf die Zeile die Akte.",
    },
    create: {
      text: "Neuen Kunden erstellen öffnet das leere Formular. Es braucht nur einen Namen.",
    },
    head: {
      text: "Oben steht der Name des Kunden. Darunter, wer die Akte angelegt und zuletzt geändert hat.",
    },
    actions: {
      text: "Unter Aktionen löschen Sie den Kunden. Eine Rückfrage kommt vorher.",
    },
    tabs: {
      text: "Die Reiter teilen die Akte auf. Hinter dem Pfeil rechts liegen noch Dateiablage, Konfiguration und Protokoll.",
    },
    general: {
      text: "Allgemein hält Name, Anschrift und Notiz. Die Anschrift finden Sie über die Suche oder tragen sie von Hand ein.",
    },
    contacts: {
      text: "Hier stehen die Ansprechpartner des Kunden mit ihrer Position. Jedes Projekt dieses Kunden kann sie übernehmen.",
    },
    machines: {
      text: "Für jede Maschine hinterlegen Sie hier einen eigenen Verkaufspreis für diesen Kunden. Im einzelnen Projekt können Sie ihn noch überschreiben. Die Einkaufspreise gehören zur Maschine. Mit dem Stern wählen Sie, mit welchem davon ein Projekt dieses Kunden startet.",
    },
    "assign-open": {
      text: "Maschine zuweisen öffnet den Katalog. Was dem Kunden schon zugewiesen ist, taucht hier nicht mehr auf.",
    },
    "assign-pick": {
      text: "Ein Klick setzt das Häkchen, mehrere gehen auf einmal. Ein Paket bringt alle seine Maschinen mit.",
    },
    "assign-add": {
      text: "Hinzufügen übernimmt die Auswahl in die Liste, noch ohne eigenen Preis. Gespeichert wird sie mit der Akte.",
    },
    materials: {
      text: "Dasselbe für Material. Ein Projekt dieses Kunden übernimmt den Preis beim Hinzufügen und kann ihn dort überschreiben.",
    },
    efforts: {
      text: "Und dasselbe für Zusatzleistungen wie Anfahrt oder Entsorgung. Auch diesen Preis können Sie je Projekt überschreiben.",
    },
    "price-modes": {
      text: "Der Verkaufspreis ist ein fester Betrag oder ein Zuschlag in Prozent. Das Zeichen rechts im Feld schaltet um, auch auf „Zum Einkaufspreis“ und „Ohne Berechnung“.",
    },
    positions: {
      text: "Hier steht der Stundensatz, den Sie mit dem Kunden vereinbart haben. Ein Projekt dieses Kunden schlägt ihn für seine Personalrollen vor.",
    },
    save: {
      text: "Speichern schreibt alle Reiter auf einmal. Ein Reiter mit einem Fehler wird dabei nach vorn geholt.",
    },
    again: {
      text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut.",
    },
    // Zusammenhänge: was der Kunde außerhalb seiner Akte bewirkt.
    "project-customer": {
      text: "Zu jedem Projekt gehört ein Kunde. Beim Anlegen wählen Sie ihn hier aus, danach steht er fest.",
    },
    currency: {
      text: "In dieser Währung stehen die Preise und Stundensätze einer Kundenakte. Im Reiter Konfiguration bekommt ein Kunde auch eine eigene.",
    },
  },
}
